import { axiosCall } from '../constants';
import { UserWhoiamDto } from './dto';

export const whoiam = (
  getAccessTokenSilently: CallableFunction,
): Promise<UserWhoiamDto> => {
  return axiosCall<UserWhoiamDto>(getAccessTokenSilently, 'whoiam', 'get');
};
